<template>
  <!-- <div>
    <img
      src="../../assets/images/nine-year/part3-bg.png"
      class="info-img"
      alt=""
    />
    <div class="activity-info">
      <div class="info-item">
        <div class="info-icon"></div>
        <div class="info-detail">活动时间：5月21日——5月28日;</div>
      </div>
      <div class="info-item">
        <div class="info-icon"></div>
        <div class="info-detail">
          参与方式：在5月21日推文后留言，替小易许一个生日愿望;
        </div>
      </div>
      <div class="info-item">
        <div class="info-icon"></div>
        <div class="info-detail">留言格式：生日愿望+易加网ID;</div>
      </div>
      <div class="info-item">
        <div class="info-icon"></div>
        <div class="info-detail">
          获奖方式：①凡留言楼层为9，19，29，39，49，59，69，79，89，99楼（按时间顺序）的10位易加注册会员即可获得礼品，每个易加会员仅有一次获奖机会；②点赞数最多的易加网用户还可以获得大奖；③获奖名单将公布在6月4日微信推文中。
        </div>
      </div>
    </div>

    <div class="activity-remind">
      （若获奖楼层/用户是非易加网注册用户，则视为无效；若在获奖后成为易加网注册用户，则可恢复获奖资格）
    </div>

    <div class="activity-msg">
      扫描或者长按下方二维码关注易加网公众号
    </div>
  </div> -->
  <div>
    <img class="info" src="../../assets/images/nine-year/info2.png">
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.info{
  width: 100vw;
}

.info-img {
  width: 100vw;
  position: absolute;
}
.activity-info {
  position: relative;
  top: 125px;
  margin: 0 52px;
  font-size: 13px;
}
.info-item {
  display: flex;
  margin-bottom:10px
}
.info-icon {
  position: relative;
  top: 5px;
  width: 7px;
  height: 11px;
  background-color: rgb(37, 125, 120);
  border-radius: 10px;
  margin-right: 5px;
}
.info-detail{
  flex: 1;
  line-height: 20px;
}
.activity-remind{
  font-size: 10px;
  margin: 0 100px;
  position: relative;
  top: 150px;
}
.activity-msg{
  position: relative;
  top: 180px;
  width: 160px;
  text-align: center;
  margin: 0 auto;
  font-size: 14px;
  text-shadow:0 3px 3px rgb(136, 136, 136)
}
</style>
